module.exports = __webpack_public_path__ + "static/media/GooglePlay.9484eddc.png";